import { render, staticRenderFns } from "./FilteredTable.vue?vue&type=template&id=16439e64"
import script from "./FilteredTable.vue?vue&type=script&lang=js"
export * from "./FilteredTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports